import { Controller } from "@hotwired/stimulus";
import { MDCTopAppBar } from "@material/top-app-bar";
import { MDCDrawer } from "@material/drawer";

export default class extends Controller {
  connect() {
    this.topAppBar = new MDCTopAppBar(this.element);
    this.drawerMenu();
  }

  disconnect() {
    if (this.topAppBar) {
      this.topAppBar.destroy();
    }
  }

  drawerMenu() {
    const drawerElement = document.querySelector(".mdc-drawer");
    const scrollTarget =
      document.querySelector("main") ||
      document.querySelector(".mdc-drawer-app-content") ||
      window;

    if (drawerElement) {
      const drawer = MDCDrawer.attachTo(drawerElement);
      this.topAppBar.setScrollTarget(scrollTarget);
      this.topAppBar.listen("MDCTopAppBar:nav", () => {
        drawer.open = !drawer.open;
      });
    }
  }
}

//  Copyright © 2018 by Northwestern University. All Rights Reserved.
